function isProblematicTimezone(tz: string): boolean {
  const problematicTimezones = [
    'null',
    'Africa/Malabo',
    'Africa/Maseru',
    'Africa/Mbabane',
    'America/Anguilla',
    'America/Antigua',
    'America/Aruba',
    'America/Bahia',
    'America/Cayman',
    'America/Dominica',
    'America/Grenada',
    'America/Guadeloupe',
    'America/Kralendijk',
    'America/Lower_Princes',
    'America/Maceio',
    'America/Marigot',
    'America/Montserrat',
    'America/Nassau',
    'America/St_Barthelemy',
    'America/St_Kitts',
    'America/St_Lucia',
    'America/St_Thomas',
    'America/St_Vincent',
    'America/Tortola',
    'Antarctica/McMurdo',
    'Arctic/Longyearbyen',
    'Asia/Bahrain',
    'Atlantic/St_Helena',
    'Europe/Busingen',
    'Europe/Guernsey',
    'Europe/Isle_of_Man',
    'Europe/Mariehamn',
    'Europe/San_Marino',
    'Europe/Vaduz',
    'Europe/Vatican',
    'Indian/Comoro',
    'Pacific/Saipan',
    'Africa/Asmara',
  ];
  return problematicTimezones.includes(tz);
}

export const timezoneOptions = (Intl as any)
  .supportedValuesOf('timeZone')
  .filter((each) => !isProblematicTimezone(each))
  .map((timezone) => {
    const date = new Date();
    let strTime: string = timezone;
    try {
      strTime = `${timezone} (${date
        .toLocaleString('en-US', {
          timeZone: `${timezone}`,
        })
        .split(',')?.[1]
        ?.substring(1)})`;
    } catch (err) {
      // Can ignore errors here, we just won't show that time zone.
      console.error(err);
    }

    return {
      text: strTime,
      value: timezone,
    };
  }) as { text: string; value: string }[];
